// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueYoutube from 'vue-youtube'
import VTooltip from 'v-tooltip'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueAmplitude from 'vue-amplitude'
// create a new Event Bus Instance
import router from './router'
import eventbus from './eventbus'
import store from './store'
import {
  createSessionRequestInterceptor,
  createUnauthorizedRetryInterceptor,
  createSessionExpiredNotifier
} from './utils/authInterceptors'
import { createApigeeHeadersInterceptor } from './utils/apigeeHeaders'
import { installVivemasFetch } from './utils/vivemasFetch'

Vue.use(Vuetify, {
  theme: {
    primary: '#0855c4',
    secondary: '#00A9FF',
    info: '#717285',
    light: '#d8d8d8',
    dark: '#EA0D90'
  }
})
Vue.use(Vuelidate)

const options = {
  customClass: {
    container: 'popup-general',
    popup: 'popup-general__info'
  },
  imageUrl: require('@/assets/characters/informa.svg'),
  imageWidth: 150,
  allowEscapeKey: false,
  allowOutsideClick: false
}
Vue.use(VueSweetalert2, options)

Vue.use(VueYoutube)

if (process.env.ENVIRONMENT !== 'dev') {
  Vue.use(VueReCaptcha, { siteKey: process.env.CAPTCHA_KEY })
}

Vue.use(VueAmplitude, {
  apiKey: process.env.AMPLITUDE_KEY,
  config: {
    includeGclid: true,
    includeFbclid: true,
    includeReferrer: true,
    includeUtm: true,
    unsetParamsReferrerOnNewSession: true,
    saveParamsReferrerOncePerSession: false
  }
})

Vue.use(VTooltip)

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.API_URL
axios.defaults.headers.get['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.interceptors.request.use(req => {
  if (store.state.user.session) {
    req.headers['Authorization'] = `Bearer ${store.state.user.session.accessToken}`
  } else if (store.state.user.user !== null) {
    req.headers['Authorization'] = `Bearer ${store.state.user.user.jwtToken}`
  } else if (store.state.user.jwt !== null) {
    req.headers['Authorization'] = `Bearer ${store.state.user.jwt}`
  }
  if (req.method.toString().toLowerCase() === 'get') {
    req.headers = { ...req.headers, 'X-Origin': 'ZONASEGURA' }
  } else {
    req.data.origen = 'ZONASEGURA'
  }
  return req
})
// Apigee exige x-api-key y las 4 cabeceras de trazabilidad; solo en las llamadas a ZS Backend.
axios.interceptors.request.use(createApigeeHeadersInterceptor())
// Vive+ también va por Apigee, pero se llama con fetch (páginas y la librería is-card-benefit)
installVivemasFetch()
// Se registra después para ejecutarse antes: axios corre los interceptores de request en orden inverso.
axios.interceptors.request.use(createSessionRequestInterceptor(store))
axios.interceptors.response.use(res => {
  // El endpoint de login maneja sus propios errores en Login.vue a través del mixin.
  // Excluirlo aquí evita el doble modal (interceptor + handler del componente).
  const isLoginEndpoint = res.config && res.config.url && res.config.url.includes('usuarios/ingresos')
  const isPrestamosVidaMontosEndpoint = res.config && res.config.url && res.config.url.includes('loans/amounts')
  const isPrestamosVidaDisponibilidadEndpoint = res.config && res.config.url && res.config.url.includes('life/loans/policies')
  const isPrestamosVidaSolicitudesEndpoint = res.config && res.config.url && res.config.url.includes('loans/applications')
  if (res.data.codigoRespuesta === '99' && !isLoginEndpoint && !isPrestamosVidaMontosEndpoint && !isPrestamosVidaDisponibilidadEndpoint && !isPrestamosVidaSolicitudesEndpoint) {
    // on error, emit an open modal event, add pass message as payload
    var msg = res.data.mensajeRespuesta.toLowerCase()
    var btnText = 'Salir'
    var routerPath = '/'
    var title = 'Atención'
    // FIXING certain messages
    if (!msg.includes('no existe') && !msg.includes('vigentes') && !msg.includes('bloqueado') && !msg.includes('inhabilitado') && !msg.includes('clave') && !msg.includes('contraseña') &&
      !msg.includes('comprobante de pago') && !msg.includes('no ha sido registrado') && !msg.includes('error al obtener información de rentas') && !msg.includes('no available coupons') && !msg.includes('general.error')
    ) {
      if (msg.includes('token')) {
        title = 'Tu sesión ha terminado'
        msg = 'Por favor, ingresa nuevamente.'
      } else {
        title = '¡Lo sentimos!'
        msg = 'En estos momentos presentamos inconvenientes pero no te preocupes, estamos trabajando para solucionarlos lo más pronto posible.'
      }

      // Display swal with options
      Vue.swal({
        titleText: title,
        text: msg,
        confirmButtonText: btnText
      }).then((result) => {
        localStorage.removeItem('jwt')
        store.state.user.session = null
        store.state.user.jwt = null
        store.state.user.coUs = null
        store.state.user.info = null
        store.state.user.user = null
        store.state.user.polizas = null
        store.state.user.historyPayments = null
        store.state.user.exp = null
        store.state.user.names = null
        router.push(routerPath).catch(() => { })
      })
    }
    return Promise.reject(res)
  }
  if (isLoginEndpoint && res.data.codigoRespuesta === '99') {
    return Promise.reject(res)
  }
  return res
})
axios.interceptors.response.use(null, createUnauthorizedRetryInterceptor(store, axios))
store.subscribe(createSessionExpiredNotifier({ swal: options => Vue.swal(options), router, storage: localStorage }))

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  eventbus,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js